import { Text } from '@visx/text';
import React, { FC } from 'react';

type DefaultCircleDivisionsCenterContentProps = {
    total: number;
    text?: string;
};

export const DefaultCircleDivisionsCenterContent: FC<DefaultCircleDivisionsCenterContentProps> = ({ total, text }) => {
    return (
        <>
            <Text fontWeight={500} fontSize={20} lineHeight={26} fill="#000" dy={text ? -5 : 0} textAnchor="middle" verticalAnchor="middle">
                {total}
            </Text>
            {text && (
                <Text fontWeight={500} fontSize={14} fill="#000" dy={15} textAnchor="middle" verticalAnchor="middle">
                    {text}
                </Text>
            )}
        </>
    );
};
